import { compose } from "recompose";
import { withStyles } from "@material-ui/core/styles";
import ActionButtons from "./ActionButtons";
import styles from "./styles";

const enhance = compose(withStyles(styles));

export default enhance(ActionButtons);
